var PopoverTrigger;

(function (PopoverTrigger) {
  PopoverTrigger["HOVER"] = "hover";
  PopoverTrigger["FOCUS"] = "focus";
  PopoverTrigger["CLICK"] = "click";
})(PopoverTrigger || (PopoverTrigger = {}));

export { PopoverTrigger };
//# sourceMappingURL=Popover.types.js.map
